import React, { useState, useEffect } from "react";
import useCustomMutation from "../../../../Hooks/useCustomMutation";
import { Row, Col } from "reactstrap";
import ButtonSubmit from "../../../Buttons/ButtonSubmit";
import EditProfilePicture from "../../../Profile/EditProfilePicture";
import { countryList } from "../../../Countries/countries";
import { title } from "../../../Common/Title/Title";

import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";

function EditSpeaker({ userId, eventID, details, token, setIsOffcanvasOpen }) {
  const [showImage, setShowImage] = useState(null);
  const [uploadImg, setUploadImg] = useState(null);
  const [inputs, setInputs] = useState({});
  const key = ["mySpeakers", eventID];
  const mutation = useCustomMutation(key);
  const handleChange = (event) => {
    const { name, value } = event.target;
    setInputs((inputs) => ({ ...inputs, [name]: value }));
  };
  const toggleSaveChanges = (e) => {
    e.preventDefault();
    const Method = "PATCH",
      url = `speakers/${details?._id}`,
      isJSON = true;
    const formdata = new FormData();
    Object.entries(inputs).forEach(([key, value]) => {
      if (value) formdata.append(key, value);
    });
    if (uploadImg) {
      formdata.append("photo", uploadImg);
    }

    const data = {
      endPoint: url,
      bodyContent: formdata,
      Method: Method,
      displayMessage: "Profile successfully updated",
      token: token,
      isJSON: isJSON,
    };
    mutation.mutate(data);
  };

  // console.log("inputs...", inputs);

  useEffect(() => {
    if (mutation?.isSuccess) {
      setIsOffcanvasOpen(false);
    }
    if (details) {
      const {
        title,
        photo,
        firstName,
        lastName,
        email,
        jobTitle,
        phoneNumber,
        organization,
        city,
        country,
        speakerBiography,
      } = details;
      setShowImage(photo);
      setInputs({
        title,
        firstName,
        lastName,
        email,
        jobTitle,
        phoneNumber,
        organization,
        city,
        country,
        speakerBiography,
      });
    }
  }, [mutation?.isSuccess, details]);

  return (
    <div className="w-100 d-flex justify-content-center p-3">
      <form
        noValidate
        autoComplete="off"
        data-testid="form"
        onSubmit={toggleSaveChanges}
      >
        <Row>
          <Col md={12}>
            <div className="d-flex mb-3 justify-content-center">
              <EditProfilePicture
                showImage={showImage}
                setShowImage={setShowImage}
                setUploadImg={setUploadImg}
                iconSize={80}
                iconColor="#F68A20"
                imgHeight={100}
                imgWidth={100}
                imgBorder="50%"
              />
            </div>
          </Col>
          <Col md={12} lg={12}>
            <label>
              <span className="text-danger">*</span>Title
            </label>
            <select
              name="title"
              value={inputs.title}
              onChange={handleChange}
              className="mb-3 form-control"
              style={{ borderRadius: 7 }}
              required
            >
              <option value={inputs?.title}>{inputs?.title}</option>
              {title?.map((title, i) => {
                if (inputs?.title !== title) {
                  return (
                    <option key={i} value={title}>
                      {title}
                    </option>
                  );
                }
              })}
            </select>
          </Col>

          <Col md={6} lg={6}>
            <label>
              <span className="text-danger">*</span>First name
            </label>
            <input
              type="text"
              name="firstName"
              value={inputs?.firstName}
              placeholder="Enter First name"
              onChange={handleChange}
              style={{ borderRadius: 7 }}
              className="mb-3 form-control fromInput"
              required
            />
          </Col>
          <Col md={6} lg={6}>
            <label>
              <span className="text-danger">*</span>Last name
            </label>
            <input
              type="text"
              name="lastName"
              value={inputs?.lastName}
              placeholder="Enter Last name"
              onChange={handleChange}
              style={{ borderRadius: 7 }}
              className="mb-3 form-control fromInput"
              required
            />
          </Col>
          <Col md={6} lg={6}>
            <label>
              <span className="text-danger">*</span>Email
            </label>
            <input
              type="email"
              name="email"
              value={inputs?.email}
              placeholder="Enter email"
              onChange={handleChange}
              style={{ borderRadius: 7 }}
              className="mb-3 form-control fromInput"
              required
            />
          </Col>
          <Col md={6} lg={6}>
            <label>
              <span className="text-danger">*</span>Job Title
            </label>
            <input
              type="text"
              name="jobTitle"
              value={inputs?.jobTitle}
              placeholder="Enter Job Title"
              onChange={handleChange}
              style={{ borderRadius: 7 }}
              className="mb-3 form-control fromInput"
              required
            />
          </Col>
          <Col md={6} lg={6}>
            <label>
              <span className="text-danger">*</span>Organization Name
            </label>
            <input
              type="text"
              name="organization"
              value={inputs?.organization}
              placeholder="Enter organization name"
              onChange={handleChange}
              style={{ borderRadius: 7 }}
              className="mb-3 form-control fromInput"
              required
            />
          </Col>
          <Col md={6} lg={6}>
            <label>
              <span className="text-danger">*</span>Phone Number
            </label>
            <div className="phone-input-container">
              <PhoneInput
                international
                countryCallingCodeEditable={false}
                defaultCountry="ZA"
                value={inputs.phoneNumber ? inputs.phoneNumber : null}
                onChange={(value) =>
                  setInputs({ ...inputs, phoneNumber: value })
                }
                className="custom-phone-input"
              />
            </div>
          </Col>
          <Col md={6} lg={6}>
            <label>
              <span className="text-danger">*</span>City
            </label>
            <input
              type="text"
              name="city"
              value={inputs?.city}
              placeholder="Enter City"
              onChange={handleChange}
              style={{ borderRadius: 7 }}
              className="mb-3 form-control fromInput"
              required
            />
          </Col>
          <Col md={6} lg={6}>
            <label className="event__form__Creation">Country</label>
            <select
              name="country"
              value={inputs.country}
              onChange={handleChange}
              className="mb-3 form-control"
              style={{ borderRadius: 7 }}
              required
            >
              {countryList?.map((country, i) => (
                <option key={i}> {country} </option>
              ))}
            </select>
          </Col>
          <Col md={12} lg={12}>
            <label className="event__form__Creation">Bio</label>
            <textarea
              value={inputs.speakerBiography}
              onChange={handleChange}
              placeholder="Write here..."
              className="mb-3 form-control fromInput"
              rows={5}
              required
            ></textarea>
          </Col>
          <div className="mb-3"></div>
          <div className="w-100 d-flex justify-content-center">
            <ButtonSubmit
              Title="Submit"
              ColorText="white"
              BorderColor="#F68A20"
              BackgroundColor="#F68A20"
              borderRadius="25px"
              handleOnclick={toggleSaveChanges}
              pending={mutation?.isLoading}
            />
          </div>
        </Row>
      </form>
    </div>
  );
}

export default EditSpeaker;
